// app/(auth)/login/admin/page.tsx

import { Link } from "react-router-dom";
import { ROUTES } from "../../../../lib/constants";
import PasswordLoginForm from "../../../../components/auth/PasswordLoginForm";

export default function AdminLoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-primary p-4 relative">
      {/* Ambient background accents */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-golden-accent/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-20 w-80 h-80 rounded-full bg-golden-accent/5 blur-3xl" />
      </div>

      <div className="relative w-full max-w-5xl flex rounded-2xl ring-1 ring-dark-border/60 shadow-2xl overflow-hidden bg-dark-secondary/70 backdrop-blur-xl">
        {/* Left Panel: Admin Form */}
        <div className="w-full md:w-1/2 flex flex-col justify-center p-8 md:p-12">
          <div className="flex items-center mb-8">
            <img src="/G1.svg" alt="Logo" className="w-10 h-10 mr-3" />
            <span className="text-2xl font-bold tracking-tight text-text-primary">Livelong Wealth</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-text-primary mb-2">Admin Login</h1>
          <p className="text-text-secondary mb-8">Enter your Admin Login ID and Password.</p>
          <PasswordLoginForm />
          <p className="mt-4 text-xs text-text-secondary">
            New admin?{" "}
            <Link to={ROUTES.REGISTER_ADMIN} className="text-golden-accent hover:underline">
              Register here
            </Link>
          </p>
        </div>

        {/* Right Panel: Info */}
        <div className="hidden md:flex flex-col items-center justify-center w-1/2 bg-gradient-to-br from-dark-tertiary to-dark-secondary p-10 text-text-primary relative">
          <div className="absolute inset-0 flex items-center justify-center opacity-30">
            <div className="w-72 h-72 rounded-full border border-dark-border/60" />
            <div className="absolute w-44 h-44 rounded-full border border-dark-border/50" />
          </div>
          <div className="relative flex flex-col items-center">
            <div className="bg-dark-border/40 rounded-2xl p-6 mb-6 ring-1 ring-dark-border">
              <img src="/G1.svg" alt="Admin Icon" className="w-16 h-16" />
            </div>
            <h2 className="text-2xl font-bold mb-2 text-center">Administrator Access</h2>
            <p className="text-center text-base font-medium text-text-secondary max-w-sm">
              Access the control panel securely to manage users, plans, and settings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
